var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{staticClass:"v1-app"},[_c('router-view',{attrs:{"locale":_vm.locale}}),(_vm.preloader)?_c('v-overlay',{attrs:{"opacity":".5"}},[_c('v-progress-circular',{attrs:{"align":"center","indeterminate":"","size":"64"}})],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }